import {
  OMSMetricsRequestSchema,
  OMSMetricsResponseSchema,
} from "@redotech/redo-model/fulfillments/metrics";

export const getOrderToShipTime = {
  name: "getOrderToShipTime" as const,
  input: OMSMetricsRequestSchema,
  output: OMSMetricsResponseSchema,
};
